import React from 'react';
import { Heart } from 'lucide-react';
import { Button } from './ui/button';
import { charities } from '../data/mockData';
import { useLanguage } from '../context/LanguageContext';

const CharitiesSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16" style={{
      background: 'linear-gradient(180deg, #1a0f38 0%, #160c30 100%)'
    }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            {t('charitiesTitle')}
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            {t('charitiesDesc')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {charities.map((charity) => (
            <div 
              key={charity.id} 
              className="bg-[#1a1a2e]/70 rounded-xl p-6 border border-gray-700/30 transition-all duration-300 hover:border-pink-500/30 hover:shadow-lg hover:shadow-pink-500/10"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-600 to-purple-600 flex items-center justify-center flex-shrink-0">
                  <Heart className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white">{charity.title}</h3>
                  <p className="text-pink-400 text-sm">{charity.arabicTitle}</p>
                </div>
              </div>
              <p className="text-gray-400 text-sm mb-4 leading-relaxed">{charity.description}</p>
              <Button 
                variant="outline" 
                className="w-full border-pink-500/50 text-pink-400 hover:bg-pink-500/10"
              >
                {t('supportCause')}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CharitiesSection;
